import React, { useState, useRef } from 'react';
import {
  Cog6ToothIcon,
  LinkIcon,
  LinkSlashIcon,
} from '@heroicons/react/24/solid';
import { useClickOutside } from 'services/useClickOutside';

const EmbeddedNotepadClusterSettingsMenu = ({
  showPreview,
  onToggleViewMode,
  onChangeCluster,
  onUnlinkCluster,
  disabled = false,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useClickOutside([menuRef], () => setMenuOpen(false), menuOpen);

  const closeAndRun = (action) => {
    if (disabled) return;
    setMenuOpen(false);
    action?.();
  };

  return (
    <div className="relative shrink-0" ref={menuRef}>
      <button
        type="button"
        onClick={() => !disabled && setMenuOpen((open) => !open)}
        disabled={disabled}
        className="rounded-lg p-1.5 text-gray-500 transition-colors hover:bg-gray-200/80 hover:text-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
        aria-label="Cluster settings"
        aria-expanded={menuOpen}
      >
        <Cog6ToothIcon className="h-5 w-5" />
      </button>

      {menuOpen && (
        <div className="absolute right-0 top-full z-50 mt-1 min-w-[220px] rounded-lg border border-gray-200 bg-white py-1 shadow-lg">
          <button
            type="button"
            onClick={() => closeAndRun(onChangeCluster)}
            className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-gray-700 transition-colors hover:bg-gray-50"
          >
            <LinkIcon className="h-4 w-4 text-gray-500" />
            Change cluster
          </button>
          <button
            type="button"
            onClick={() => closeAndRun(onUnlinkCluster)}
            className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-gray-700 transition-colors hover:bg-gray-50"
          >
            <LinkSlashIcon className="h-4 w-4 text-gray-500" />
            Unlink cluster
          </button>

          <div className="my-1 border-t border-gray-100" />

          <div className="flex items-center justify-between gap-3 px-3 py-2">
            <div className="min-w-0">
              <p className="text-sm font-medium text-gray-800">Note cards</p>
              <p className="text-xs text-gray-500">
                {showPreview ? 'Header + preview' : 'Header only'}
              </p>
            </div>
            <button
              type="button"
              role="switch"
              aria-checked={showPreview}
              aria-label="Toggle note card preview"
              onClick={onToggleViewMode}
              className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-transparent transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 ${
                showPreview ? 'bg-blue-600' : 'bg-gray-300'
              }`}
            >
              <span
                className={`pointer-events-none inline-block h-4 w-4 rounded-full bg-white shadow-sm transition-transform ${
                  showPreview ? 'translate-x-4' : 'translate-x-0.5'
                }`}
              />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmbeddedNotepadClusterSettingsMenu;
